import React from "react";
import PropTypes from "prop-types";

export default function NoIndex(props) {
  return (
    <span>
      <span dangerouslySetInnerHTML={{__html: `<!--noindex-->`}} />
      {props.children}
      <span dangerouslySetInnerHTML={{__html: `<!--/noindex-->`}} />
    </span>
  );
}

NoIndex.propTypes = {
  children: PropTypes.element
};
